/**
 * Takes a list of actions and combines them
 * @param {...Object} allActions - actions to be combined
 * @return {Object} actions - object holding all the combined actions
 */
function combineActions(...allActions) {
    return store =>
        allActions.reduce((combined, actions) => {
            for (let i in actions) {
                let action = actions[i];
                let value = action.name;
                if (typeof action === 'function')
                    action = Object.defineProperty(action(store), 'name', {
                        value,
                    });
                combined[i] = action;
            }
            return combined;
        }, {});
}

export default combineActions;
